<template>
  <b-overlay
    :show="overlay.main"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card no-body>
      <b-row>
        <b-col
          sm="6"
          class="card-border"
        >
          <b-card-body>
            <div class="text-center text-md-left mt-3">
              <h3 class="text-primary">
                {{ $t('withdraw-title') }}
              </h3>
              <p>{{ $t('withdraw-dec', { currency: coin }) }}</p>
            </div>
            <b-img
              fluid
              :src="require('@/assets/images/illustration/pricing-Illustration.svg')"
              class="pricing-trial-img"
              alt="svg img"
            />
          </b-card-body>
        </b-col>
        <b-col sm="6">
          <b-card-body>
            <b-alert
              class="p-2"
              show
              variant="danger"
            >
              <p>{{ $t('withdraw-warning-dec', { currency: coin }) }}</p>
            </b-alert>
            <!--            <b-alert-->
            <!--              class="p-2 text-center"-->
            <!--              show-->
            <!--              variant="success"-->
            <!--            >-->
            <!--              <span>{{ $t('withdrawableAmount') }} : </span>-->
            <!--              <span dir="ltr">-->
            <!--                {{ quantity ? helpers.toFixed(quantity , decimals):0 }} {{ coin }}-->
            <!--              </span>-->
            <!--            </b-alert>-->
            <ValidationObserver v-slot="{ invalid }">
              <b-form class="mt-2">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label-for="coin"
                      :label="$t('coin')"
                    >
                      <b-form-input
                        id="coin"
                        v-model="coin"
                        readonly
                        name="coin"
                        :placeholder="$t('coin')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      label-for="network"
                      :label="$t('Network')"
                    >
                      <b-form-select
                        id="network"
                        v-model="network"
                        text-field="network.nick_name"
                        value-field="network.nick_name"
                        :options="coinInfo.currency_network"
                        :placeholder="$t('Network')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('destinationAddress')"
                      :rules="`required|cryptoWalletAddress:${symbol}`"
                    >
                      <b-form-group
                        label-for="destinationAddress"
                        :label="$t('destinationAddress')"
                      >
                        <b-form-input
                          id="destinationAddress"
                          v-model="destinationAddress"
                          name="destinationAddress"
                          :placeholder="$t('destinationAddress')"
                          autocomplete="off"
                        />
                        <span class="text-danger">{{ $t(errors[0]) }}</span>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col
                    cols="12"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('Amount')"
                      :rules="{ required: true, regex: /^\d+(\.\d+)?$/ }"
                    >
                      <b-row align-v="center">
                        <b-col
                          cols="8"
                          sm="7"
                          md="9"
                        >
                          <b-form-group
                            :label="$t('Amount')"
                            label-for="Amount"
                          >
                            <b-form-input
                              id="Amount"
                              v-model.number="price"
                              name="Amount"
                              :placeholder="$t('Amount')"
                            />

                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-button
                            style="margin-top: 6px;"
                            @click="price = quantity"
                          >
                            max
                          </b-button>
                        </b-col>
                      </b-row>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col class="d-flex flex-column justify-content-center">
                    <b-button
                      variant="success"
                      @click="showBarcode =!showBarcode"
                    >
                      {{ $t('barcodeScanning') }}
                    </b-button>
                    <p
                      class="d-flex justify-content-center text-danger mt-1 error"
                    >
                      {{ $t(error) }}
                    </p>

                    <qrcode-stream
                      v-if="showBarcode"
                      @decode="onDecode"
                      @init="onInit"
                    />

                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      data-toggle="modal"
                      data-target="#myModal"
                      variant="primary"
                      class="mt-2 btn-block"
                      :disabled="invalid"
                      @click="setInvoiceDetails"
                    >
                      {{ $t('send') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </ValidationObserver>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
    <b-overlay
      :show="overlay.withdraw"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        v-if="items.length !== 0"
        class="d-none d-md-block"
        :title="$t('lastWithdrawal')"
      >
        <b-row align-h="center">
          <b-col cols="12">
            <b-table
              :items="items"
              :fields="fields"
              striped
              sticky-header="1000px"
            >
              <template #cell(created_at)="data">
                <span>{{ getFormattedDate(data.item["created_at"]) }}</span>
              </template>
              <template #cell(status)="data">
                <div class="d-flex align-items-center">
                  <b-button
                    :variant="data.item['status'] === 'pending' ? 'warning' : data.item['status'] === 'success' ? 'success' :data.item['status'] === 'in_progress'? 'outline-info': 'danger'"
                    size="sm"
                    style="display: block; width: 140px"
                  > {{ $t('withdraw' + '-' + data.item['status']) }}</b-button>
                  <feather-icon
                    v-if="data.item['status'] === 'rejected' && data.item['comment_reject']"
                    :id="`popover-button-variant-${data.item.id}`"
                    icon="HelpCircleIcon"
                    class="cursor-pointer mx-1"
                    size="20"
                    href="#"
                    tabindex="0"
                  />
                  <b-popover
                    placement="top"
                    :target="`popover-button-variant-${data.item.id}`"
                    variant="secondary"
                    triggers="focus"
                  >
                    {{ data.item['comment_reject'] ? data.item['comment_reject']:'' }}
                  </b-popover>
                </div>
              </template>
              <template #cell(transaction_id)="data">
                <div class="d-flex">
                  <b-button
                    variant="info "
                    size="sm"
                    style="display: block"
                    :disabled="!data.item.transaction"
                    @click="() => triggerTransactionModal(data.item)"
                  >
                    {{ $t('transaction_id') }}
                  </b-button>
                  &nbsp;
                  <b-button
                    v-if="data.item.remaining_cancellation_time !== 0"
                    variant="danger"
                    style="width: 130px;"
                    @click="cancelWithdrawal(data.item.id)"
                  >
                    <span v-if="!data.item.cancelLoading">{{ $t('cancel-withdrawal') }}</span>
                    <b-spinner
                      v-else
                      variant="primary"
                      type="grow"
                      small
                    />
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-col>
          <b-col cols="auto">
            <b-pagination
              v-if="totalTransactions > perPageTransactions"
              v-model="currentpageTransactions"
              :total-rows="totalTransactions"
              :per-page="perPageTransactions"
              align="fill"
              size="sm"
              class="mb-1"
            />
          </b-col>
        </b-row>
      </b-card>

      <b-card
        class="d-md-none"
        :title="$t('lastWithdrawal')"
      >
        <b-row align-h="center">
          <b-col cols="12">
            <div
              v-for="(item, index) in items"
              :key="index"
              :class="$store.state.appConfig.layout.skin === 'dark' ? 'card-bg' : 'transaction-card'"
              class="mb-2"
            >
              <div class="d-flex justify-content-between">
                <div>{{ $t('coin') }}</div>
                <h5>{{ item.currency }}</h5>

              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>{{ $t('Network') }}</div>
                <h5>{{ item.network }}</h5>

              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>{{ $t('amount') }}</div>
                <h5>{{ item.amount }}</h5>

              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>{{ $t('date') }}</div>
                <h5>{{ getFormattedDate(item.date) }}</h5>

              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>{{ $t('status') }}</div>
                <div class="d-flex align-items-center">
                  <feather-icon
                    v-if="item.status === 'rejected' && item.comment_reject"
                    :id="`popover-button-variant-${item.id}+mobile`"
                    icon="HelpCircleIcon"
                    class="cursor-pointer"
                    size="20"
                    href="#"
                    tabindex="0"
                  />
                  <b-popover
                    placement="top"
                    :target="`popover-button-variant-${item.id}+mobile`"
                    variant="secondary"
                    triggers="focus"
                  >
                    {{ item.comment_reject ? item.comment_reject:'' }}
                  </b-popover>
                  <div style="margin: 0 5px;" />
                  <b-button
                    :variant="item.status === 'pending' ? 'warning' : item.status === 'success' ? 'success' : item.status === 'in_progress'? 'outline-info':'danger'"
                    size="sm"
                    style="display: block; width: 140px"
                  > {{ $t('withdraw' + '-' + item.status) }}
                  </b-button>
                  &nbsp;
                  <b-button
                    v-if="item.remaining_cancellation_time !== 0"
                    variant="danger"
                    size="sm"
                    style="display: block; width: 140px"
                    @click="cancelWithdrawal(item.id)"
                  >
                    <span v-if="!item.cancelLoading">{{ $t('cancel-withdrawal') }}</span>
                    <b-spinner
                      v-else
                      variant="primary"
                      type="grow"
                      small
                    />
                  </b-button>
                </div>
              </div>
              <div class="d-flex justify-content-between mt-2">
                <b-button
                  variant="info"
                  size="sm"
                  style="width:100%"
                  :disabled="!item.transaction"
                  @click="() => triggerTransactionModal(item)"
                >
                  {{ $t('transaction_id') }}
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col cols="auto">
            <b-pagination
              v-if="totalTransactions > perPageTransactions"
              v-model="currentpageTransactions"
              :total-rows="totalTransactions"
              :per-page="perPageTransactions"
              align="fill"
              size="sm"
              class="mb-1"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
    <b-modal
      v-model="confirmModal"
      :title="$t('invoice_confirm')"
      centered
      size="lg"
      no-close-on-backdrop
    >
      <template>
        <b-overlay
          :show="getFeeLoading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-card
            class="mb-0 invoiceModal"
            :title="$t('invoice.brandName',{brand_name:getBrandName()})"
          >
            <b-row
              align-h="end"
              class="mt-n2 mb-1"
            >
              <b-col cols="auto">
                <span class="text-dark">
                  {{
                    new Date()
                      .toLocaleString(this.$i18n.locale === 'fa' ? 'fa-IR' : 'en-US',{
                        dateStyle: 'short',
                        timeStyle: 'short',
                      })
                  }}
                </span>
              </b-col>
            </b-row>
            <b-row
              class="row-bg p-1 font-weight-bold"
              style="background-color: #e3ffd7;"
            >
              <b-col
                cols="12"
                class="text-primary"
              >
                <span>{{ $t('invoice.withdrawalFromYourWallet') }}</span>
              </b-col>
              <div
                v-if="modalInvoiceColumns"
                class="table-invoice-crypto-withdraw w-100 mt-1"
              >
                <b-table
                  responsive
                  stacked
                  :items="modalInvoiceColumns"
                  :fields="invoiceHeader"
                >
                  <template
                    #cell(fee)=""
                  >
                    <div>
                      {{ fee }}
                    </div>
                    <div v-if="!fee">
                      <b-alert
                        variant="danger"
                        show
                        class="p-2 text-center"
                      >
                        {{ $t('cant-calculate-fee') }}
                      </b-alert>
                    </div>
                    <div
                      class="text-danger"
                    >
                      <span>** </span>
                      <span>{{ $t('crypto_withdraw_invoice_fee_description') }}</span>
                    </div>
                  </template>
                  <template
                    #cell(total)=""
                  >
                    <div>
                      {{ helpers.numberWithCommas(helpers.toFixed((Number(price) - Number(fee)), decimals)) }}
                    </div>
                  </template>
                </b-table>
              </div>
            </b-row>
          </b-card>
        </b-overlay>
      </template>
      <template #modal-footer>
        <b-button
          size="md"
          variant="success"
          :disabled="!fee"
          @click="openConfirmModal"
        >
          <span v-if="!confirmPending">
            {{ $t('widrawModal.confirm') }}
          </span>
          <b-spinner
            v-else
            small
            size="10"
            variant="light"
            type="grow"
          />
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="otpModal"
      :title="$t('confirm_withdraw')"
      centered
      size="md"
      hide-footer
      no-close-on-backdrop
    >
      <validation-observer
        #default="{invalid}"
      >
        <b-row v-if="isEnableSecurityPassword">
          <b-col>
            <div
              class="my-1"
            >
              {{ $t('withdraw_security_password_description') }}
            </div>
            <b-button
              :to="`/${$i18n.locale}/profile/security`"
              class="mb-1"
              variant="success"
              size="sm"
            >
              {{ $t('security') }}
            </b-button>
            <b-form
              class="auth-login-form mb-2"
            >
              <!-- pin -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="security-password">{{ $t('security-password') }}</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('security-password')"
                  vid="security-password"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="security-password"
                      v-model="tradingPassword"
                      name="security-password"
                      placeholder="0000"
                      type="password"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div
              v-if="mobile"
              class="my-1"
            >
              {{ $t('withdraw_confirm_description', { mobile }) }}
            </div>
            <div>
              <p
                style="border-bottom: 1px dashed;width: max-content; margin-top: 10px;cursor: pointer; color: blue;"
                @click="senderModal=true"
              >
                {{ $t('send-otp-ways') }}
              </p>
            </div>
            <b-form
              class="auth-login-form mb-2"
            >
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="code">{{ $t('confirm_withdraw_code') }}</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('confirm_withdraw_code')"
                  vid="code"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="code"
                      v-model="confirmCode"
                      name="code"
                      placeholder="0000"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-button
              block
              size="md"
              variant="warning"
              :disabled="verifyCounter !== 0"
              @click="resendSMS"
            >
              <div v-if="!resendOtpLoading">
                <span>
                  {{ $t('resend') }}
                </span>
                <span v-if="verifyCounter !== 0">({{ verifyCounter }})</span>
              </div>
              <b-spinner
                v-else
                small
                size="10"
                variant="light"
                type="grow"
              />
            </b-button>
          </b-col>
          <b-col cols="6">
            <b-button
              block
              size="md"
              :disabled="invalid || confirmCode.length < 4"
              variant="success"
              @click="verify"
            >
              <span v-if="!verifyLoading">
                {{ $t('widrawModal.confirm') }}
              </span>
              <b-spinner
                v-else
                small
                size="10"
                variant="light"
                type="grow"
              />
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
      v-model="transactionIdModal"
      centered
      :title="$t('show_transaction_id')"
      ok-only
      :ok-title="$t('show_in_network')"
      no-close-on-backdrop
      :ok-disabled="!selectedTransactionNetwork"
      @ok="openTransaction"
    >
      <b-form-group
        id="popover-manual-2"
        label-for="transaction_id"
        :label="$t('transaction_id')"
      >
        <copy-to-clipboard
          :text="selectedTransactionId"
          @copy="copyTransaction"
        >
          <b-input-group class="mb-2">
            <b-form-input
              id="transaction_id"
              v-model="selectedTransactionId"
              readonly
              name="transaction_id"
              :placeholder="$t('transaction_id')"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="CopyIcon"
                size="20"
              />
            </b-input-group-append>
          </b-input-group>
        </copy-to-clipboard>
        <b-popover
          target="popover-manual-2"
          :show.sync="pop2"
          triggers="click"
          placement="bottom"
        >
          {{ $t('copied') }}
        </b-popover>
      </b-form-group>
    </b-modal>
    <b-modal
      v-model="statusModal"
      :title="`${$t('withdrawal-status')}: ${$t(withdrawalStatus)}`"
      centered
      size="md"
      no-close-on-backdrop
      hide-footer
      @close="getWalletTransactions()"
    >
      <div>
        <p>{{ $t('your-withdrawal-is-currently') }}: <strong>{{ $t(withdrawalStatus) }}</strong></p>
        <p v-if="timer > 0">
          {{ $t('you-can-cancel-your-withdrawal-in') }}: {{ timer }} {{ $t('seconds') }}
        </p>
        <b-button
          variant="danger"
          :disabled="isCancelDisabled"
          @click="cancelWithdrawal(newlyCreatedWithdrawal.withdrawal_id)"
        >
          <span v-if="!cancelWithdrawalLoading">{{ $t('cancel-withdrawal') }}</span>
          <b-spinner
            v-else
            variant="primary"
            type="grow"
            small
          />
        </b-button>
      </div>
    </b-modal>
    <OtpsenderWaysModal
      :sender-modal="senderModal"
      @send-verification-code="sendVerificationCodeMethod"
      @submit="resendSMS"
      @close="senderModal=false"
    />
  </b-overlay>
</template>
<script>
import cryptoWithdrawMixin from '@/modules/crypto/views/logic/customer-wallets/cryptoWithdraw'
import OtpsenderWaysModal from '@/views/theme1/components/otpSenderWaysModal.vue'

export default {
  components: {
    OtpsenderWaysModal,
  },
  mixins: [cryptoWithdrawMixin],
}
</script>
<style lang="scss">
.invoiceModal .card-title{
  color: $primary;
}
.card-border {
  border-right: 1px solid #e3e1e9;
}
.transaction-card {
  background-color: #efefef;
  padding: 15px;
  border-radius: 5px;
}
.nameOfTheClass {
  padding: 20px !important;
}
.table-invoice-crypto-withdraw .table{
  background: transparent !important;
}
.table-invoice-crypto-withdraw .table tbody{
  background: transparent !important;
}
.table-invoice-crypto-withdraw .table tr{
  background: transparent !important;
}
.table-invoice-crypto-withdraw .table td{
  color: #283046 !important;
  padding: 6px !important;
}
.table-invoice-crypto-withdraw .table td::before{
  width: 14rem !important;
}
@media screen and (max-width:1024px) {
  .table-invoice-crypto-withdraw .table td::before{
    width: 4rem !important;
  }
}
</style>
